/**
 * Pilot model.
 */
import Channel from '@shared/classes/channel';
import EpgEvent from '@shared/classes/epgEvent';
import FastEvent from '@shared/classes/fastEvent';

/**
 * Pilot type. LIVE for live channels and VOD for vod content.
 */
enum PilotType {
  LIVE = 'live',
  VOD = 'vod',
}

/**
 * Props interface for pilot component.
 */
interface PilotProps {
  asset?: EpgEvent | FastEvent;
  channel?: Channel;
  display?: boolean;
  hint?: {
    action: () => void;
    visible: boolean;
  };
  type?: PilotType;
}

/**
 * Props interface for pilot poster component.
 */
interface PilotPosterProps {
  id?: string;
  poster?: string;
}

export { PilotType };
export type { PilotProps, PilotPosterProps };
